/* groups */

import Alert from './alert';
import Grid from './grid';
import Hero from './hero';

/* singles */

// import PreOrder from './preorder/script';

export default {
	...Alert,
	...Grid,
	...Hero
};
